<div class="error-image" data-test="error">
  <img src="assets/images/ico-erro.svg" alt="" class="animated fadeInDown">
  <div class="animated fadeInUp description-error">
    <p>
      {{ statusCode(code)?.title }}
    </p>
    <p *ngIf="statusCode(code)?.description">
      {{ statusCode(code)?.description }}
    </p>
    <small>
      {{ statusCode(code)?.errorDescription }}
    </small>
  </div>
</div>
